import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import AntropometriaTable from '../components/AntropometriaTable';

export default function AntropometriaListPage() {
  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <AntropometriaTable />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
